import api from "../../utils/apiUserTienda";

// Endpoints públicos (funcionan sin token; la tienda se resuelve por dominio).

export const validarInvitacion = async (token) => {
  const res = await api.get("/api/tienda/acceso/invitaciones/validar", { params: { token } });
  return res.data;
};

export const aceptarInvitacion = async ({ token, password, confirmPassword }) => {
  const res = await api.post("/api/tienda/acceso/invitaciones/aceptar", {
    token,
    password,
    confirmPassword,
  });
  return res.data;
};

export const solicitarReset = async (correo) => {
  const res = await api.post("/api/tienda/acceso/password/solicitar-reset", { correo });
  return res.data;
};

export const validarReset = async (token) => {
  const res = await api.get("/api/tienda/acceso/password/validar-reset", { params: { token } });
  return res.data;
};

export const restablecerPassword = async ({ token, password, confirmPassword }) => {
  const res = await api.post("/api/tienda/acceso/password/restablecer", {
    token,
    password,
    confirmPassword,
  });
  return res.data;
};
